import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components/macro';
import { connect } from 'react-redux';
import translate from '../TranslateHOC';
import { Link } from 'react-router-dom';
import Isvg from 'react-inlinesvg';
import { parse } from 'query-string';
import {
  SEARCH_RELATIVE_URL,
  SEARCH_IMG_THUMBNAIL_URL,
  MAX_NUM_CYSILL_RESULTS,
  BOXSET_ID,
} from '../../constants';
import {
  decodeHtml,
  getSearchCategories,
  filterArrayByValue,
  highlightResultsText,
  replaceString,
  isGenreMatch,
  IsvgWrapper,
} from '../../helpers';
import {
  searchResultsRequest,
  updateSearchKeyword,
  fetchCategories,
  searchCategoryContent,
  clearCysillCheck,
  fetchCategoryMapping,
} from '../../actions';
import searchIcon from '../../img/icons/search.svg';
import heroBoxSetMissingImageDark from '../../img/heroBoxSetMissingImageDark.png';
import heroBoxSetMissingImageLight from '../../img/heroBoxSetMissingImageLight.png';
import heroBoxSetBrokenImageLight from '../../img/heroBoxSetBrokenImageLight.png';
import heroBoxSetBrokenImageDark from '../../img/heroBoxSetBrokenImageDark.png';
import SearchPlaceholderDark from '../../img/searchPlaceholderDark.png';
import SearchPlaceholderLight from '../../img/searchPlaceholderLight.png';
import { SearchInput as SearchInputV2 } from '../../v2/components/header/searchInput/SearchInput';
import { Button as ButtonV2 } from '../../v2/components/button/Button';
import { device } from '../../v2/Theme';
import { debounce } from 'lodash';
import { Paging } from '../Paging';
import PageMeta from '../PageMeta';

let RESULTS_PER_PAGE = 8;

class Search extends Component {
  numPages =
    this.props.searchResults && this.props.searchResults.length > 0
      ? Math.ceil(this.props.searchResults.length / RESULTS_PER_PAGE)
      : 0;
  currPage = 1;

  constructor(props) {
    super(props);
    this.currPage = parse(this.props.location.search).p
      ? parseInt(parse(this.props.location.search).p, 10)
      : 1;
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.props.fetchCategoryMapping(this.props.curLang);
    this.props.fetchCategories();
    if (
      parse(this.props.location.search).s &&
      parse(this.props.location.search).s !== ''
    ) {
      this.props.updateSearchKeyword(parse(this.props.location.search).s);
    }
    this.highlightResults();
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (this.props.curLang !== nextProps.curLang) {
      this.props.fetchCategoryMapping(nextProps.curLang);
    }
  };

  componentDidUpdate = (event) => {
    this.highlightResults();
  };

  componentWillUnmount = () => {
    // Clear searchKeyword on leaving page
    this.props.updateSearchKeyword('');
  };

  UNSAFE_componentWillUpdate = (nextProps) => {
    if (nextProps.searchKeyword !== this.props.searchKeyword) {
      // New search
      this.props.clearCysillCheck();
      this.submitSearchRequest(nextProps.searchKeyword);
      if (!Array.isArray(this.props.searchKeyword)) {
        // Re-search, (not initial page load)
        this.currPage = 1;
      }
    }
    // Chuck cysill warning on error // needs testing
    if (
      nextProps.cysillResults !== this.props.cysillResults &&
      nextProps.cysillResults.success === false
    ) {
      if (
        nextProps.cysillResults.errors &&
        nextProps.cysillResults.errors.length > 0 &&
        nextProps.cysillResults.errors[0].indexOf('403') > -1
      ) {
        // Log error here
        if (window.logError) {
          window.logError(
            'Error Cysill ',
            nextProps.cysillResults.errors[0],
            'Search.js'
          );
        }
      }
    }

    if (nextProps.searchResults.length !== this.props.searchResults.length) {
      // Num pages changed
      this.numPages = Math.ceil(
        nextProps.searchResults.length / RESULTS_PER_PAGE
      );
      this.currPage = this.currPage <= this.numPages ? this.currPage : 1;
    }

    if (nextProps.curLang !== this.props.curLang) {
      this.props.fetchCategories();
    }

    if (
      Object.keys(nextProps.categories).length > 0 &&
      (nextProps.searchKeyword !== this.props.searchKeyword ||
        JSON.stringify(nextProps.categories) !==
          JSON.stringify(this.props.categories))
    ) {
      this.props.getSearchResults(nextProps.searchKeyword);
      this.searchCategories(
        nextProps.searchKeyword,
        nextProps.categories,
        nextProps.searchMappingItems
      );
    }
  };

  handleFormSubmit = (keywords) => {
    this.submitSearchRequest(keywords);
    this.props.history.push(SEARCH_RELATIVE_URL + keywords);
    this.props.updateSearchKeyword(keywords);
  };
  handleSwitchToAlternative = (event) => {
    event.preventDefault();
    let replace = event.currentTarget.dataset.replace;
    this.props.updateSearchKeyword(replace);
  };
  submitSearchRequest = (_searchKeyword) => {
    this.props.getSearchResults(_searchKeyword.trim());
  };

  setPageNum = (_pageNum) => {
    window.event.preventDefault();
    this.currPage = _pageNum;
    window.scrollTo(0, 0);
  };

  highlightResults = () => {
    // check the results for matching keywords
    highlightResultsText(
      this.refs.results,
      this.props.searchKeyword,
      'search-card__title'
    );
    highlightResultsText(
      this.refs.results,
      this.props.searchKeyword,
      'search-card__sub-title'
    );
    highlightResultsText(
      this.refs.resultsCategories,
      this.props.searchKeyword,
      'search-panel-card__blurb'
    );
  };

  searchCategories = (keywords, categories, categoriesMapping) => {
    this.props.searchCategoryContent(
      filterArrayByValue(
        getSearchCategories(keywords, categories),
        categoriesMapping,
        keywords
      )
    );
  };

  displayAlternative = (original, replace, index, length) => {
    return replaceString(original, replace, index, length).toLowerCase();
  };

  trimCysillSuggestions = (results) => {
    if (results && results.length > 0) {
      for (var i = 0; i < results.length; i++) {
        if (
          results[i].suggestions &&
          results[i].suggestions.length > MAX_NUM_CYSILL_RESULTS
        ) {
          results[i].suggestions = results[i].suggestions.slice(
            0,
            MAX_NUM_CYSILL_RESULTS
          );
        }
      }
    }
    return results;
  };

  handleImage = (image) => {
    if (image) {
      return `backgroundImage: url('${SEARCH_IMG_THUMBNAIL_URL + image}')`;
    } else {
      return this.props.theme.name === 'light'
        ? `background-image:url(${heroBoxSetMissingImageLight})`
        : `background-image:url(${heroBoxSetMissingImageDark})`;
    }
  };

  imageFallback = (ev, path) => {
    ev.target.onerror = null;
    ev.target.src = path;
  };

  handleChange = debounce((event) => {
    const { value } = event?.target;
    this.submitSearchRequest(value);
    this.props.history.push({
      pathname: '/search',
      search: `?s=${value}`,
    });
    this.props.updateSearchKeyword(value);
  }, 400);

  handleClear = () => {
    updateSearchKeyword('');
    this.submitSearchRequest('');
    this.props.updateSearchKeyword('');
  };

  render() {
    const { strings, searchCat, searchCatLoading, searchCatError, categories } =
      this.props;
    const categoryList = categories.categories;
    let hasSearchKeyword = this.props.searchKeyword.length > 0;
    let numResults = this.props.searchResults.length;
    let hasSearchResults = numResults > 0;

    let searchResultsPaged = this.props.searchResults.slice(
      (this.currPage - 1) * RESULTS_PER_PAGE,
      this.currPage * RESULTS_PER_PAGE
    );

    let cysillResults = this.trimCysillSuggestions(
      this.props.cysillResults.result
    );
    let hasCysillResults =
      cysillResults &&
      cysillResults.length > 0 &&
      cysillResults[0].suggestions.length > 0;
    let searchKeyword = this.props.searchKeyword;

    return (
      <div className="search-page main">
        <PageMeta
          title={strings.search}
          description={strings.metaDescriptionSearch}
        />
        <SearchInputContainer>
          <SearchInputV2
            history={this.props.history}
            handleChange={this.handleChange}
            handleClear={this.handleClear}
            hasSearchKeyword={hasSearchKeyword}
            isHeader={true}
            autoFocus={true}
            strings={strings}
          />
        </SearchInputContainer>
        <div
          className={
            'search-page__header' + (hasSearchKeyword ? ' hidden' : '')
          }
        >
          <h1 className="search-page__title">
            {this.props.strings.searchPageTitle}
          </h1>
          <img
            src={
              this.props.theme.name === 'light'
                ? SearchPlaceholderLight
                : SearchPlaceholderDark
            }
            alt={strings.searchPageTitle}
          />
          {categoryList && categoryList.length > 0 && (
            <div className="search-categories">
              <h4>{strings.tryACategory}</h4>
              <ul className="link-list">
                {categoryList &&
                  Object.keys(categoryList).length > 0 &&
                  Object.keys(categoryList).map(
                    (key) =>
                      !isGenreMatch(categoryList[key].id, BOXSET_ID) && (
                        <li className="link-list__item" key={key}>
                          <ButtonV2
                            link={'/Categories/' + categoryList[key].id}
                            label={categoryList[key].genre}
                            size="small"
                            type="secondary"
                          />
                        </li>
                      )
                  )}
              </ul>
            </div>
          )}
        </div>
        {hasSearchKeyword && (
          <div className="search-page__results-block">
            {
              // LOADING
              this.props.searchResultsIsLoading && (
                <div className="alert alert--loading">
                  <h2>{this.props.strings.loading}</h2>
                </div>
              )
            }

            {
              // NO RESULTS
              !this.props.searchResultsIsLoading && !hasSearchResults && (
                <div className="alert alert--noresults">
                  <h2>
                    {this.props.strings.noSearchResults} ‘
                    {this.props.searchKeyword}’
                  </h2>
                </div>
              )
            }

            {hasCysillResults && !hasSearchResults && (
              <div className="search-panel-spelling">
                <h4>{this.props.strings.didYouMeanQ}</h4>
                <div className="search-panel-spelling__inner">
                  {Object.keys(cysillResults).map((key) => (
                    <div key={key}>
                      <div className={'search-panel-spelling__results'}>
                        {Object.keys(cysillResults[key].suggestions).map(
                          (key2) => (
                            <button
                              className="search-panel-spelling__result link"
                              onClick={this.handleSwitchToAlternative}
                              key={key2}
                              data-replace={this.displayAlternative(
                                searchKeyword,
                                cysillResults[key].suggestions[key2],
                                cysillResults[key].start,
                                cysillResults[key].length
                              )}
                            >
                              {this.displayAlternative(
                                searchKeyword,
                                cysillResults[key].suggestions[key2],
                                cysillResults[key].start,
                                cysillResults[key].length
                              )}
                            </button>
                          )
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {
              // NO RESULTS - DISPLAY CATEGORIES
              !this.props.searchResultsIsLoading &&
                !hasSearchResults &&
                categoryList &&
                categoryList.length > 0 && (
                  <div className="search-categories">
                    <h4>{strings.tryACategory}</h4>
                    <ul className="link-list">
                      {categoryList &&
                        Object.keys(categoryList).length > 0 &&
                        Object.keys(categoryList).map(
                          (key) =>
                            !isGenreMatch(categoryList[key].id, BOXSET_ID) && (
                              <li className="link-list__item" key={key}>
                                <ButtonV2
                                  link={'/Categories/' + categoryList[key].id}
                                  label={categoryList[key].genre}
                                  size="small"
                                  type="secondary"
                                />
                              </li>
                            )
                        )}
                    </ul>
                  </div>
                )
            }

            {
              // RESULTS
              !this.props.searchResultsIsLoading && hasSearchResults && (
                <div className="search-results">
                  <div className="search-results__inner" ref="results">
                    <h2 className="alert alert--results">
                      {numResults + this.props.strings.searchResultsTitle}{' '}
                      <span>‘{this.props.searchKeyword}’</span>
                    </h2>
                    {Object.keys(searchResultsPaged).map((key) => (
                      <div key={key}>
                        <div className={'card__search-results'}>
                          <Link
                            to={searchResultsPaged[key].prog_link}
                            className="search-card__inner"
                            aria-label={`Watch ${searchResultsPaged[key].title}`}
                          >
                            <SearchCardImageContainer className="search-card__image">
                              <SearchCardImage
                                className="search-card__image-result-inner"
                                src={
                                  SEARCH_IMG_THUMBNAIL_URL +
                                  searchResultsPaged[key].thumbnail
                                }
                                onError={(e) =>
                                  this.imageFallback(
                                    e,
                                    this.props.theme.name === 'light'
                                      ? heroBoxSetBrokenImageLight
                                      : heroBoxSetBrokenImageDark
                                  )
                                }
                                alt={searchResultsPaged[key].title}
                              />
                              {/* <div
                                className="search-card__image-result-inner"
                                style={{
                                  backgroundImage: `url('${
                                    SEARCH_IMG_THUMBNAIL_URL +
                                    searchResultsPaged[key].thumbnail
                                  }')`,
                                }}
                              /> */}
                            </SearchCardImageContainer>
                            <div className="search-card__details">
                              <h3
                                className="search-card__title"
                                data-string={decodeHtml(
                                  searchResultsPaged[key].title
                                )}
                              >
                                {decodeHtml(searchResultsPaged[key].title)}
                              </h3>
                              {searchResultsPaged[key].programme_title && (
                                <h4
                                  className="search-card__sub-title"
                                  data-string={decodeHtml(
                                    searchResultsPaged[key].programme_title
                                  )}
                                >
                                  {decodeHtml(
                                    searchResultsPaged[key].programme_title
                                  )}
                                </h4>
                              )}
                              <p className="search-card__short_billing">
                                {decodeHtml(
                                  searchResultsPaged[key].short_billing
                                )}
                              </p>
                            </div>
                          </Link>
                        </div>
                      </div>
                    ))}
                    {this.numPages > 1 && (
                      <Paging
                        history={this.props.history}
                        numPages={this.numPages}
                        searchKeyword={this.props.searchKeyword}
                        currPage={this.currPage}
                        setPageNum={this.setPageNum}
                      />
                    )}
                  </div>
                </div>
              )
            }
          </div>
        )}
        {hasSearchKeyword &&
          !this.props.searchResultsIsLoading &&
          !searchCatLoading &&
          !searchCatError &&
          !hasSearchResults &&
          searchCat &&
          Object.keys(searchCat).length > 0 && (
            <div className="search-cat-results">
              <div
                className="search-cat-results__inner"
                ref="resultsCategories"
              >
                <div
                  className="search-cat-results__blurb"
                  data-string={`${strings.searchLookingFor} ${
                    searchCat.item ? searchCat.item : searchCat.genre
                  } ${strings.searchYouMighLike}`}
                >
                  <h4>
                    {strings.lookingFor}{' '}
                    <span>
                      {decodeHtml(
                        searchCat.genre ? searchCat.genre : searchCat.item
                      )}
                    </span>
                    ?
                  </h4>
                </div>

                {Object.keys(searchCat.progs).length > 0 && (
                  <ul className="search-cat-results__progs">
                    {Object.keys(searchCat.progs).map((key) => (
                      <li key={key} className="search-cat-results__prog">
                        <IsvgWrapper addClasses='icon'>
                          <Isvg src={searchIcon} />
                        </IsvgWrapper>
                        <Link
                          to={searchCat.progs[key].prog_link}
                          aria-label={searchCat.progs[key].title}
                        >
                          {searchCat.progs[key].title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
                <ButtonV2
                  link={`/Categories/${searchCat.id}`}
                  label={`All ${searchCat.genre} programmes`}
                  size="small"
                />
              </div>
            </div>
          )}
      </div>
    );
  }
}

const SearchCardImageContainer = styled.div`
  display: none;
  min-width: 200px;
  height: 116px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 4px;
  @media ${device.tablet} {
    display: flex;
  }
  ${(props) =>
    props.theme.name === 'light' &&
    `background-image:url(${heroBoxSetMissingImageLight})`};
  ${(props) =>
    props.theme.name === 'dark' &&
    `background-image:url(${heroBoxSetMissingImageDark})`};
  box-shadow: ${(props) =>
    props.theme.name === 'light'
      ? `0px 16px 32px rgba(0, 0, 0, 0.05), 0px 8px 16px rgba(0, 0, 0, 0.05), 0px 4px 8px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.05);`
      : `0 0 0 1px #3f3f3e, 0px 2px 2px -3px rgb(254 246 232 / 50%), 0px 18px 32px -4px rgb(164 71 10 / 5%), 0px 12px 16px -6px rgb(248 165 27 / 5%), 0px 6px 8px -4px rgb(252 210 141 / 5%);`};
`;

const SearchCardImage = styled.img`
  border-radius: 4px;
  width: 100%;
  object-fit: cover;
  overflow: hidden;
`;

const SearchInputContainer = styled.div`
  form {
    display: flex;
    max-width: 100%;
    > div {
      width: 100%;
    }
    @media ${device.tablet} {
      display: none;
    }
  }
`;

const mapStateToProps = (state) => {
  return {
    searchKeyword: state.searchKeyword.success,
    searchResults: state.searchResults.success,
    searchResultsIsLoading: state.searchResults.loading,
    searchResultsErrored: state.searchResults.error,
    cysillResults: state.cysill.success,
    cysillError: state.cysill.error,
    categories: state.categories.success,
    searchCat: state.searchCategoryContent.success,
    searchCatLoading: state.searchCategoryContent.loading,
    searchCatError: state.searchCategoryContent.error,
    searchMappingItems: state.searchMappingItems.success,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSearchResults: (keywords) => dispatch(searchResultsRequest(keywords)),
    updateSearchKeyword: (lang) => dispatch(updateSearchKeyword(lang)),
    clearCysillCheck: () => dispatch(clearCysillCheck()),
    fetchCategories: () => dispatch(fetchCategories()),
    searchCategoryContent: (keywords) =>
      dispatch(searchCategoryContent(keywords)),
    fetchCategoryMapping: (lang) => dispatch(fetchCategoryMapping(lang)),
  };
};

export default withTheme(
  translate(connect(mapStateToProps, mapDispatchToProps)(Search))
);
